import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Users, Building, RefreshCw, Lightbulb } from 'lucide-react';

const PainSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Wann lohnt sich ein <span className="text-blue-600">ERP-System</span>?
          </h2>
          <p className="text-lg text-gray-600">
            Viele denken bei "ERP-System" an teure Software und komplizierte IT-Projekte. 
            Bei manchen Systemen stimmt das auch heute noch - aber es gibt auch moderne Alternativen.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <Card className="border-2 border-blue-200 bg-blue-50">
            <CardContent className="p-8">
              <div className="flex items-center mb-6">
                <Users className="h-8 w-8 text-blue-600 mr-3" />
                <h3 className="text-2xl font-bold text-blue-900">
                  Auch für kleine Unternehmen
                </h3>
              </div>
              <p className="text-blue-800 leading-relaxed mb-4">
                Du brauchst keine eigenen Server und keine IT-Abteilung. Business Central läuft in der Cloud - 
                du kannst sogar mit nur einem Nutzer starten.
              </p>
              <p className="text-blue-800 leading-relaxed">
                Das bedeutet: Überschaubare Kosten, aber trotzdem alle Vorteile eines professionellen ERP-Systems. 
                Dein Team kann sich auf die wichtigen Aufgaben konzentrieren, statt Zeit mit Verwaltung zu verschwenden.
              </p>
            </CardContent>
          </Card>

          <Card className="border-2 border-green-200 bg-green-50">
            <CardContent className="p-8">
              <div className="flex items-center mb-6">
                <RefreshCw className="h-8 w-8 text-green-600 mr-3" />
                <h3 className="text-2xl font-bold text-green-900">
                  Zeit für ein neues System?
                </h3>
              </div>
              <p className="text-green-800 leading-relaxed mb-4">
                Nutzt du noch ein altes ERP-System aus den 2000ern? Oder verschiedene Programme, 
                die nicht miteinander sprechen? Dann kennst du das Problem.
              </p>
              <p className="text-green-800 leading-relaxed">
                Ein modernes Cloud-ERP kann wie ein Befreiungsschlag wirken: Plötzlich funktioniert alles reibungslos, 
                deine Mitarbeiter sind zufriedener und du hast endlich wieder Zeit für dein Geschäft.
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-8 max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <Lightbulb className="h-12 w-12 text-purple-600 mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-4 text-purple-900">
              Kennst du diese Situationen?
            </h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h4 className="font-bold text-gray-900 mb-3">Alte Systeme nerven</h4>
              <ul className="space-y-2 text-gray-600">
                <li>• Dein Server braucht ständig Updates</li>
                <li>• Für jede Änderung brauchst du einen Programmierer</li>
                <li>• Wichtige Funktionen fehlen einfach</li>
                <li>• Deine Mitarbeiter umgehen das System mit Excel</li>
              </ul>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h4 className="font-bold text-gray-900 mb-3">So geht's besser</h4>
              <ul className="space-y-2 text-gray-600">
                <li>• Updates passieren automatisch im Hintergrund</li>
                <li>• Neue Funktionen kommen regelmäßig dazu</li>
                <li>• Deine Daten sind sicher in der Cloud</li>
                <li>• Alles funktioniert einfach - ohne IT-Stress</li>
              </ul>
            </div>
          </div>

          <div className="text-center mt-8">
            <a 
              href="#contact" 
              className="inline-block bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-200"
            >
              Produktdemo anfragen
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainSection; 